
define('template!sdcInput',[''],function(template){return '<label class="implicit">\r\n\t<span class="{{model.labelClass}}">{{model.name}}</span>\r\n\t<input class="{{model.inputClass}}" type="{{model.type}}" ng-model="model.ngModel" tooltip="{{model.name}}" />\r\n</label>';});

